<figure class="d-flex flex-column">
  <img alt="Arbeitnehmerüberlassung" class="mx-auto h-50 w-25" ngSrc="assets/images/anue.png" height="1753" width="1240">
  <figcaption class="mx-auto"><a href="assets/pdf/arbeitnehmerueberlassung.pdf">Arbeitnehmerüberlassung.pdf</a></figcaption>
</figure>
